<template>
  <a-flex vertical gap="middle">
    <DocumentsMarkingCodesHeader />

    <a-table
      :columns="tableColumns"
      :data-source="tableData"
      :loading="isDataLoading"
      :pagination="false"
      :sticky="{ offsetHeader: 65 }"
      :row-key="(item: MarkingCodesDocumentsTableItem) => item.id"
      @resizeColumn="handleResizeColumn"
      :row-selection="
        isDataLoading
          ? {}
          : {
              selectedRowKeys: selectedRowKeys,
              onChange: onRowSelectionChange,
            }
      "
    >
      <template #headerCell="{ column }">
        <DocumentsMarkingCodesTableHeader :column="column" />
      </template>

      <template #bodyCell="{ column, record }">
        <DocumentsMarkingCodesTableCell :column="column" :record="record" />
      </template>
    </a-table>

    <a-pagination
      style="margin-top: 20px; display: flex; justify-content: end"
      v-model:current="markingCodesDocumentsStore.pagination.current"
      v-model:pageSize="markingCodesDocumentsStore.pagination.pageSize"
      :showQuickJumper="markingCodesDocumentsStore.pagination.showQuickJumper"
      :showSizeChanger="markingCodesDocumentsStore.pagination.showSizeChanger"
      :showTotal="markingCodesDocumentsStore.pagination.showTotal"
      :total="markingCodesDocumentsStore.pagination.total"
      @change="markingCodesDocumentsStore.pagination.onChangePagination"
    >
      <template #buildOptionText="props">
        <span>{{ props.value }} / странице</span>
      </template>
    </a-pagination>
  </a-flex>
</template>

<script setup lang="ts">
import DocumentsMarkingCodesHeader from "@/components/product/marking/documentsMarkingCodes/DocumentsMarkingCodesHeader.vue";
import { handleResizeColumn } from "@/common/table/handleResizeColumn";
import {
  type MarkingCodesDocumentsTableItem,
  useMarkingCodesDocuments,
} from "@/stores/product/marking/marking-codes-documents.store";
import { computed, onMounted } from "vue";
import DocumentsMarkingCodesTableHeader from "@/components/product/marking/documentsMarkingCodes/DocumentsMarkingCodesTableHeader.vue";
import DocumentsMarkingCodesTableCell from "@/components/product/marking/documentsMarkingCodes/DocumentsMarkingCodesTableCell.vue";

const markingCodesDocumentsStore = useMarkingCodesDocuments();

const tableData = computed(() => markingCodesDocumentsStore.tableData || []);
const tableColumns = computed(
  () => markingCodesDocumentsStore.columnsFiltered || [],
);
const isDataLoading = computed(() => markingCodesDocumentsStore.isDataLoading);
const selectedRowKeys = computed(
  () => markingCodesDocumentsStore.selectedRowKeys,
);

const onRowSelectionChange = (
  selectedRowKeys: MarkingCodesDocumentsTableItem["id"][],
) => {
  markingCodesDocumentsStore.updateSelectedItems(selectedRowKeys);
};

onMounted(() => markingCodesDocumentsStore.loadData());
</script>

<style scoped lang="scss">
.ant-pagination {
  margin-bottom: 70px;
}
</style>
